import React from 'react';
import {
	useMarketStateTools,
} from '@app/site/secured/rateshopper/rates/dashboard/fragment/__market-state/common/hook/useMarketStateTools';
import Message from '@app/component/message/Message';

const PriceRecommendationLiteGlobalNotification = React.memo(() => {
	const tools = useMarketStateTools();

	const hasPriceRecommendationLiteStates = tools.marketStateSnapshot.hasPriceRecommendationStates();

	return hasPriceRecommendationLiteStates ? <Message state="recommendation">
		We have highlighted some dates that present the most significant risk for a market correction. Please review them
		and adjust your prices.
	</Message> : null;
});

export default PriceRecommendationLiteGlobalNotification;